import React, { useState, useEffect } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { backendApi } from "../../api/apiService";
import { FaSpinner } from "react-icons/fa";
import { Circles } from 'react-loader-spinner'
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { BsArrowLeftCircleFill } from "react-icons/bs";

const Process = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [candidate, setCandidate] = useState(null);
  const [aiResponse, setAIResponse] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [resfromAI, setresfromAI] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [summary, setSummary] = useState();
  const [description, setDescription] = useState();
  const [experience, setExperience] = useState();
  const [numberOfPositions, setNumberOfPositions] = useState();
  const [status, setStatus] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [priority, setPriority] = useState();
  const [jobType, setJobType] = useState();
  const [salary, setSalary] = useState();
  const [jobLocation, setJobLocation] = useState();
  const [editableValues, setEditableValues] = useState();
  const [editableValuesAI, setEditableValuesAI] = useState();
  const [jobDescription, setJobDescription] = useState();

  useEffect(() => {
    setTimeout(() => {
      document.getElementById("NewVacancyMenu").classList.add("active");
    }, 500);
    getCandidateById(location.state.props);
    // processInit();
  }, []);

  const getCandidateById = (jobId) => {
    var req = {
      functionName: "getJobOpeningDetailsById",
      job_opening_id: jobId.id ? jobId.id : jobId,
      site_id: localStorage.getItem("siteId"),
    };
    backendApi(req).then((response) => {
      if (response.success == 1) {
        setCandidate(response.JobOpeningData[0]);
        setJobDescription(response.JobOpeningData[0].job_description);
        if (response.JobOpeningData[0].job_description) {
          setEditableValues(response.JobOpeningData[0].job_description);
        } else {
          let editableValue = {
            description: `
              <p><strong>Summary:</strong> ${response.JobOpeningData[0].summary
              }</p>
              <p><strong>Description:</strong> ${response.JobOpeningData[0].description
              }</p>
              <p><strong>Skills Required:</strong> ${response.JobOpeningData[0].job_opening_skill
                .map((s) => s.skill_name)
                .join(", ")}</p>
              <p><strong>Number of Positions:</strong> ${response.JobOpeningData[0].no_of_position
              }</p>
              <p><strong>Start Date:</strong> ${formatDate(
                response.JobOpeningData[0].start_date
              )}</p>
              <p><strong>End Date:</strong> ${formatDate(
                response.JobOpeningData[0].end_date
              )}</p>
              <p><strong>Status:</strong> ${response.JobOpeningData[0].status
              }</p>
              <p><strong>Priority:</strong> ${response.JobOpeningData[0].priority
              }</p>
              <p><strong>Experience:</strong> ${response.JobOpeningData[0].experiance
              } years</p>
              <p><strong>Job Type:</strong> ${response.JobOpeningData[0].job_type
              }</p>
              <p><strong>Location:</strong> ${response.JobOpeningData[0].location
              }</p>
              <p><strong>Salary:</strong> ${response.JobOpeningData[0].salary
              }</p>
            `,
          };
          setEditableValues(editableValue.description);
        }
      } else {
        console.eror("error");
        return false;
      }
    });
  };
  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}-${month}-${year}`;
  }

  function formatDateToCustomFormat(dateString) {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };

    return new Date(dateString).toLocaleDateString("en-GB", options);
  }

  const processInit = () => {
    setIsLoading(true);
    setIsEditing(false);
    var req = {
      functionName: "getJobOpeningTemplate",
      site_id: localStorage.getItem("siteId"),
      job_opening_id: location.state.props.id
        ? location.state.props.id
        : location.state.props,
    };
    // const callBackendApi = () => {
    backendApi(req)
      .then((response) => {
        if (response.success === "1") {
          const jobData = response.data[0];
          const jobText = jobData.message.content;
          const jobDetails = JSON.parse(jobText);
          console.log("JD", jobDetails);
          setresfromAI(true)
          setAIResponse(jobDetails);
          const editableValue = {
            description: `
                <p><strong>Job Title:</strong> ${jobDetails["Job Title"]
              }</p><br/>
                <p><strong>Job Description:</strong> ${jobDetails["Job Description"]
              }</p><br/>
                <p><strong>Requirements:</strong> ${jobDetails["Requirements"]
              }</p><br/>
                <p><strong>Qualifications:</strong> ${jobDetails["Qualifications"]
              }</p><br/>
                <p><strong>Experience:</strong> ${jobDetails["Experience"]
              }</p><br/>
                <p><strong>Job Type:</strong> ${jobDetails["Job Type"]}</p><br/>
                <p><strong>Location:</strong> ${jobDetails["Location"]}</p><br/>
                <p><strong>Number of Openings:</strong> ${jobDetails["Number of Openings"]
              }</p><br/>
                <p><strong>Start Date:</strong> ${formatDate(
                jobDetails["Start Date"]
              )}</p><br/>
                <p><strong>End Date:</strong> ${formatDate(
                jobDetails["End Date"]
              )}</p>
              `,
          };
          setEditableValuesAI(editableValue.description);
          setIsLoading(false);
          // setApiError(false);
        } else {
          console.error("Error in API response");
          setIsLoading(false);
          // setApiError(true);
        }
      })
      .catch((error) => {
        console.error("Error in API call", error);
        toast.warn("Something went wrong please try again!", {
          containerId: "GF",
        });
        setIsLoading(false);
        // setApiError(true);
      });
    // };

    // callBackendApi();
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };

  const reProcessAPI = () => {
    processInit();
  };
  const handleEditClick = () => {
    setIsEditing(true);
  };
  const handleEditCancel = () => {
    setIsEditing(false);
  };

  const renderJobDetails = () => {
    return Object.entries(aiResponse).map(([key, value]) => (
      <div className="row mb-3" key={key}>
        <div className="col-md-12">
          <strong>{key} :</strong>
        </div>
        <div className="col-md-12">
          {key === "Start Date" || key === "End Date"
            ? formatDate(value)
            : value}
        </div>
      </div>
    ));
  };

  const handleQuillChange = (content) => {
    setEditableValues(content);
  };

  const handleQuillChangeAI = (value) => {
    setEditableValuesAI(value);
  };

  const renderDefaultTemplate = () => {
    return (

      <div className="col-md-12 mt-3">
        <h5 className="d-flex justify-content-between align-items-center mb-2">
          Template 1
          {/* <button onClick={editDetails} className="btn-theme1 h-auto">
            Edit
          </button> */}
        </h5>

        {/* {!isEdit?( 
       <div>
       <hr></hr>
        <p>
          <strong>Summary:</strong> {candidate.summary}
        </p>
        <p>
          <strong>Description:</strong> {candidate.description}
        </p>
        <p>
          <strong>Number of Positions:</strong> {candidate.no_of_position}
        </p>
        <p>
          <strong>Start Date:</strong> {formatDate(candidate.start_date)}
        </p>
        <p>
          <strong>End Date:</strong> {formatDate(candidate.end_date)}
        </p>
        <p>
          <strong>Status:</strong> {candidate.status}
        </p>
        <p>
          <strong>Priority:</strong> {candidate.priority}
        </p>
        <p>
          <strong>Experience:</strong> {candidate.experiance} years
        </p>
        <p>
          <strong>Job Type:</strong> {candidate.job_type}
        </p>
        <p>
          <strong>Location:</strong> {candidate.location}
        </p>
        <p>
          <strong>Salary:</strong> {candidate.salary}
        </p>
        </div>):( */}
        <div className="col-md-12">
          <ReactQuill value={editableValues} onChange={handleQuillChange} />
        </div>
      </div>
    );
  };

  const handleSaveJD = () => {
    var req = {
      functionName: "saveJD",
      job_opening_id: location.state.props,
      site_id: localStorage.getItem("siteId"),
      job_description: editableValues,
    };
    backendApi(req).then((response) => {
      if (response.success == 1) {
        toast.success("JD saved successfully", { containerId: "GF" });
        setTimeout(() => {
          getCandidateById(location.state.props);
        }, 1500);
      } else {
        toast.warn("Something went wrong!", { containerId: "GF" });
      }
    });
  };

  const handleSaveAiJD = () => {
    var req = {
      functionName: "saveJD",
      job_opening_id: location.state.props,
      site_id: localStorage.getItem("siteId"),
      job_description: editableValuesAI,
    };
    backendApi(req).then((response) => {
      if (response.success == 1) {
        toast.success("JD saved successfully", { containerId: "GF" });
        setTimeout(() => {
          getCandidateById(location.state.props);
        }, 1500);
      } else {
        toast.warn("Something went wrong!", { containerId: "GF" });
      }
    });
  };

  const goBack = () => {
    navigate(-1);
  };
  const handleBack = (can) => {
    if (location.state?.from === 'jobhistory') {
      navigate('/schedule/createJobOpening');
    }
    else if (location.state?.from === 'assignRecruiter') {
      navigate('/assignRecruiter', { state: { props: can } });
    }
    else {

    }
  };
  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <LeftMenu />
        <div className="content-wrapper">
          <Header Header="JD Processing" />
          <div className="main-container">
            <div className="card main-card">
              <div className="card-body">
                <ToastContainer
                  enableMultiContainer
                  containerId={"GF"}
                  position="bottom-right"
                  autoClose={1400}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="colored"
                />
                <div className="row">
                  {/* <LeftMenu /> */}
                  <div className="col-md-12 xilliRight-wrapper">
                    <div className="xilliWrap">
                      <div className="row">

                        {!jobDescription ? (
                          <div>
                            {candidate && (
                              <div className="col-md-12">
                                <div className="processDiv">
                                  <div className="processDivTop">
                                    <div className="processItem w-100 mb-1">
                                      <span className="processHead text-secondary">Summary : </span>
                                      <span className="processContent">
                                        {candidate.summary}
                                      </span>
                                    </div>
                                    <div className="processItem w-100 mb-1">
                                      <span className="processHead text-secondary">
                                        Description :{" "}
                                      </span>
                                      <span className="processContent">
                                        {candidate.description}
                                      </span>
                                    </div>
                                    <div className="processItem w-100 mb-1">
                                      <span className="processHead text-secondary">
                                        Skills Required:{" "}
                                      </span>
                                      <span className="processContent">
                                        {candidate.job_opening_skill
                                          .map((s) => s.skill_name)
                                          .join(", ")}
                                      </span>
                                    </div>
                                    <div className="processItem mb-1">
                                      <span className="processHead text-secondary">Status : </span>
                                      <span className="processContent">
                                        {candidate.status}
                                      </span>
                                    </div>
                                    <div className="processItem mb-1">
                                      <span className="processHead text-secondary">Priority : </span>
                                      <span className="processContent">
                                        {candidate.priority}
                                      </span>
                                    </div>
                                    <div className="processItem mb-1">
                                      <span className="processHead text-secondary">Experience : </span>
                                      <span className="processContent">
                                        {candidate.experiance} Years
                                      </span>
                                    </div>
                                    <div className="processItem mb-1">
                                      <span className="processHead text-secondary">Location : </span>
                                      <span className="processContent">
                                        {candidate.location}
                                      </span>
                                    </div>
                                    <div className="processItem mb-1">
                                      <span className="processHead text-secondary">Salary : </span>
                                      <span className="processContent">
                                        {candidate.salary ? candidate.salary : "NA"}
                                      </span>
                                    </div>
                                    <div className="processItem mb-1">
                                      <span className="processHead text-secondary">Notice Period : </span>
                                      <span className="processContent">
                                        {candidate.notice_period
                                          ? isNaN(candidate.notice_period)
                                            ? candidate.notice_period
                                            : `${candidate.notice_period} Days`
                                          : "NA"}
                                      </span>
                                    </div>
                                    <div className="processItem mb-1">
                                      <span className="processHead text-secondary">Job Mode : </span>
                                      <span className="processContent">
                                        {candidate.job_mode ? candidate.job_mode : "NA"}
                                      </span>
                                    </div>
                                    <div className="processItem mb-1">
                                      <span className="processHead text-secondary">Posted On :</span>
                                      <span className="processContent">
                                        {" "}
                                        {formatDateToCustomFormat(candidate.created_on)}
                                      </span>
                                    </div>
                                    <div className="processItem mb-1">
                                      <span className="processHead text-secondary">
                                        No of positions :{" "}
                                      </span>
                                      <span className="processContent">
                                        {candidate.no_of_position}
                                      </span>
                                    </div>
                                    <div className="processItem mb-1">
                                      <span className="processHead text-secondary">Start Date : </span>
                                      <span className="processContent">
                                        {formatDate(candidate.start_date)}
                                      </span>
                                    </div>
                                    <div className="processItem mb-1">
                                      <span className="processHead text-secondary">Job Type : </span>
                                      <span className="processContent">
                                        {candidate.job_type}
                                      </span>
                                    </div>
                                  </div>

                                  <div className="row table-scroll">
                                    <div className="col-md-6">
                                      <div className="processCards">
                                        {renderDefaultTemplate()}
                                      </div>
                                    </div>
                                    <div className="col-md-6 mt-3">
                                      <div className="processCards">
                                        <div className="col-md-12">
                                          <div className="row">
                                            <div className="col-md-7">
                                              <h5 className="d-flex justify-content-between align-items-center mb-2">
                                                Template 2 (AI Generated)
                                              </h5>
                                            </div>
                                            <div className="col-md-5">
                                              {resfromAI ? (
                                                isEditing ? (
                                                  <button
                                                    onClick={handleEditCancel}
                                                    className="btn btn-btn1 btn-btn bg-secondary mb-3 me-2"
                                                  >
                                                    Close
                                                  </button>
                                                ) : (
                                                  <button
                                                    onClick={handleEditClick}
                                                    className="btn btn-btn1 btn-btn bg-secondary mb-3 me-2"
                                                  >
                                                    Edit
                                                  </button>
                                                )
                                              ) : null}

                                              <button
                                                onClick={reProcessAPI}
                                                className="btn btn-btn1 btn-btn bg-primary mb-3"
                                              >
                                                Generate
                                              </button>
                                            </div>
                                          </div>

                                          {/* <hr></hr> */}
                                          {isLoading ? (
                                            <div className="d-flex justify-content-center align-center mt-5">
                                              <span style={{ fontSize: "28px" }}>
                                                <Circles
                                                  height="80"
                                                  width="80"
                                                  color="#4fa94d"
                                                  ariaLabel="circles-loading"
                                                  wrapperStyle={{}}
                                                  wrapperClass=""
                                                  visible={true}
                                                />
                                              </span>
                                            </div>
                                          ) : !isEditing ? (
                                            renderJobDetails()
                                          ) : (
                                            <div className="col-md-12">
                                              <ReactQuill
                                                value={editableValuesAI}
                                                onChange={handleQuillChangeAI}
                                              />
                                              <br />
                                              {/* <button
                                                onClick={handleEditCancel}
                                                className="btn btn-btn1 btn-btn bg-secondary mb-3"
                                              >
                                                Cancel
                                              </button> */}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-6 text-right mt-3 mb-3">
                                      <button
                                        className="btn btn-btn1 btn-btn bg-success mb-3"
                                        onClick={handleSaveJD}
                                      >
                                        Save
                                      </button>
                                    </div>
                                    {resfromAI ? (
                                      <div
                                        className="col-md-6 text-right mt-3 mb-3"
                                        onClick={handleSaveAiJD}
                                      >
                                        <button className="btn btn-btn1 btn-btn bg-success mb-3">
                                          Save
                                        </button>
                                      </div>
                                    ) : ""}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div>
                            {candidate && (
                              <div className="processDivTop">
                                <div className="processItem w-100 mb-1">
                                  <span className="processHead text-secondary">Summary : </span>
                                  <span className="processContent">
                                    {candidate.summary}
                                  </span>
                                </div>
                                <div className="processItem w-100 mb-1">
                                  <span className="processHead text-secondary">Description : </span>
                                  <span className="processContent">
                                    {candidate.description}
                                  </span>
                                </div>
                                <div className="processItem mb-1">
                                  <span className="processHead text-secondary">Status : </span>
                                  <span className="processContent">
                                    {candidate.status}
                                  </span>
                                </div>
                                <div className="processItem mb-1">
                                  <span className="processHead text-secondary">Priority : </span>
                                  <span className="processContent">
                                    {candidate.priority}
                                  </span>
                                </div>
                                <div className="processItem mb-1">
                                  <span className="processHead text-secondary">Experience : </span>
                                  <span className="processContent">
                                    {candidate.experiance} Years
                                  </span>
                                </div>
                                <div className="processItem mb-1">
                                  <span className="processHead text-secondary">Location : </span>
                                  <span className="processContent">
                                    {candidate.location}
                                  </span>
                                </div>
                                <div className="processItem mb-1">
                                  <span className="processHead text-secondary">Salary : </span>
                                  <span className="processContent">
                                    {candidate.salary ? candidate.salary : "NA"}
                                  </span>
                                </div>
                                <div className="processItem mb-1">
                                  <span className="processHead text-secondary">Posted On :</span>
                                  <span className="processContent">
                                    {" "}
                                    {formatDateToCustomFormat(candidate.created_on)}
                                  </span>
                                </div>
                                <div className="processItem mb-1">
                                  <span className="processHead text-secondary">
                                    No of positions :{" "}
                                  </span>
                                  <span className="processContent">
                                    {candidate.no_of_position}
                                  </span>
                                </div>
                                <div className="processItem mb-1">
                                  <span className="processHead text-secondary">Start Date : </span>
                                  <span className="processContent">
                                    {formatDate(candidate.start_date)}
                                  </span>
                                </div>
                                <div className="processItem mb-1">
                                  <span className="processHead text-secondary">Job Type : </span>
                                  <span className="processContent">
                                    {candidate.job_type}
                                  </span>
                                </div>
                              </div>
                            )}
                            <br />
                            <div className="col-md-12">
                              <ReactQuill
                                value={editableValues}
                                onChange={handleQuillChange}
                              />
                            </div>
                            <div className="col-md-12 mt-3">
                              <span className="childIssueses">
                                <a className="btn-btn btn btn-btn2 btn-sm me-2" onClick={handleSaveJD}>
                                  Save
                                </a>
                                <a className="btn-btn btn btn-btn1 btn-sm" onClick={goBack}>
                                  Cancel
                                </a>
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
              type="button"
              className="floating-back-button"
              onClick={() => handleBack(candidate)}
            >
              <BsArrowLeftCircleFill size={24} />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Process;
